import { InjectionToken } from '@angular/core';

export const ENVIRONMENT = new InjectionToken<Environment>('environment');

export interface Environment {
  production: boolean;
  appName: string;
  apiBaseUrl: string;
  apiAuthUrl: string;
  docsBaseUrl: string;
  instaclause_legacy?: string;
  version: string;
  amplitudeApiKey: string;
  googleSignInClientId: string;
  // Microsoft Entra application (client) id. Empty hides the Microsoft sign-in button, so an
  // environment without the app registration shows no button instead of one that always fails.
  entraClientId: string;
  faroUrl?: string;
  // Base URL of the Accountant frontend. The Admin app links into a customer's flow from a
  // support ticket, and there is no redirect endpoint, so the link is built client side.
  accountantBaseUrl: string;
  docusignClientId: string;
  docusignAuthServer: string;
  integrationsBaseUrl: string;
  exactClientId: string;
  exactRegion: string;
  adminPulseClientId: string;
  hubSpotClientId: string;
}
